module.exports = __webpack_public_path__ + "static/media/HoloUS-logos_transparent.888ff2e9.png";